import axiosInstance from 'services/interceptor';

export const getProducts = async (category_id = 1, event_id = 0): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/customer/products?category=${category_id}&event=${event_id}`);
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
};